export default class FTPLinesRowData {
    constructor(value) {
        this.chargeType = value.chargeType[0] || "";
        this.brand = value.brand[0] || "";
        this.batchRef = value.batchRef[0] || "";
        this.chargePeriod = value.chargePeriod[0] || "";
        this.ranumber = value.ranumber[0] || "";
        this.locCode = value.locCode[0] || "";
        this.desc = value.desc[0] || "";
        this.memberNumber = value.memberNumber[0] || "";
        this.fullPoints = value.fullPoints[0] || "";
        this.halfPoints = value.halfPoints[0] || "";
        this.bonusPoints = value.bonusPoints[0] || "";
        this.totalCost = value.totalCost[0] || "";
        this.ccy = value.ccy[0] || "";
        this.rechcost = value.rechcost[0] || "";
        this.rcy = value.rcy[0] || "";
        this.rentalDays = value.rentalDays[0] || "";
        this.credate = value.credate[0] || "";
        this.rewardMilesIssued = value.rewardMilesIssued[0] || "";
        this.promoMilesIssued = value.promoMilesIssued[0] || "";
        this.chargeCode = value.chargeCode[0] || "";
    }
}